module.exports = "<base-card>\n  <div #gmap class=\"mdl-card--expand map__window\"></div>\n</base-card>\n"